module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/10-11bbfc159d6e69055a3001e5cc8a0d57.jpg";